/* eslint-disable camelcase */
import React from "react";
import { gql } from "graphql-tag";
import { navigate, RouteComponentProps } from "@reach/router";
import { Card, CardHeader } from "@material-ui/core";
import { useMutation } from "@apollo/client";
import * as TOML from "@ltd/j-toml";
import { createForm as createFormType, createFormVariables, FormType } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import logger from "services/logger";
import DefinitionsForm, { FormDefinition as Definition } from "./form";
import contentTemplate from "./template";

const CREATE_FORM = gql`
  mutation createForm($data: FormDefinitionInput!) {
    createFormDefinition(data: $data) {
      name
      content
      propertyId
      enabled
      createInterest
      formType
      skipSignature
      renderParagraphs
      ageRequirement
      ageRequirementOrDisabilityOverride
    }
  }
`;

const initialData = {
  id: null,
  name: "",
  content: contentTemplate,
  propertyId: "",
  enabled: false,
  createInterest: false,
  formType: FormType.PRE_APPLICATION,
  skipSignature: false,
  renderParagraphs: false,
  ageRequirement: 18,
  ageRequirementOrDisabilityOverride: false,
  form: null,
  formId: null,
};

const NewDefinition: React.FC<RouteComponentProps> = () => {
  const { openSnackbar } = useSnackbar();
  const [createForm] = useMutation<
  createFormType,
  createFormVariables
  >(CREATE_FORM);

  const submitForm = async (formData: Definition) => {
    if (formData.enabled) {
      try {
        TOML.parse[0.5](formData.content || "", "\n");
      } catch (e) {
        openSnackbar({ message: "Insert failed, TOML invalid", status: "error" });
        return false;
      }
    }

    try {
      const { id, form, formId, ...filteredData } = formData;
      await createForm({ variables: { data: filteredData } });
      return navigate("/dash/admin/forms");
    } catch (err) {
      return logger.sendError(err as Error);
    }
  };

  return (
    <Card>
      <CardHeader title="Create a Form Draft" subheader="Required fields marked with *" />
      <DefinitionsForm
        formType="new"
        initialData={initialData}
        handleSubmit={submitForm}
      />
    </Card>
  );
};

export default NewDefinition;
